<template>
  <div class="outer-auth-box">
    <div class="auth-box">
      <div class="image-box">
        <img src="/logo.png" alt="myket-logo" />
      </div>
      <div class="text-center">
        <div class="d-flex justify-between align-center mb-3 mt-7">
          <h3 class="primary--text">{{ $t('login.title') }}</h3>
          <SelectLanguageMenu />
        </div>
        <div class="p-2 my-3 text-xs rounded success white--text" v-if="changedStatus">{{ changedStatus }}</div>
        <!-- <p>เข้าสู่ระบบโดยใช้ ชื่อผู้ใช้งานหรือเบอร์โทรศัพท์</p> -->
      </div>
      <v-divider class="mb-3"></v-divider>
      <v-form @submit.prevent="login" :disabled="isLoggingIn">
        <v-text-field name="username" :label="$t('login.phone_number')" :placeholder="$t('login.phone_number')" id="Username"
          background-color="grey lighten-4" flat solo v-model="username" @keydown.enter="login"
          prepend-inner-icon="mdi-cellphone"></v-text-field>
        <v-text-field type="password" name="password" :placeholder="$t('login.password')" :label="$t('login.password')"
          background-color="grey lighten-4" flat id="Password" solo v-model="password" @keydown.enter="login"
          autocomplete="on" prepend-inner-icon="mdi-lock-outline"></v-text-field>
        <div class="d-flex justify-end align-items-center mb-2">
          <v-btn to="password-recovery" text class="link-forgot">{{ $t('login.forgot_password') }}</v-btn>
        </div>
        <v-btn dark elevation="0" color="darkprimary" block class="py-3" large @click="login" :loading="isLoggingIn"
          :disabled="isLoggingIn">{{ $t('login.title') }}</v-btn>
      </v-form>
      <div class="my-3 text-xs text-center">{{ $t('login.no_account') }}</div>
      <v-btn dark elevation="0" color="info darken-2" outlined block class="py-3" large link
        to="signup">{{ $t('login.register') }}</v-btn>
    </div>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('login.invalid_username_or_password') }}
    </v-snackbar>
    <div class="divider-box">
      <v-divider></v-divider>
      <div class="text">{{ $t('or') }}</div>
      <v-divider></v-divider>
    </div>
    <div class="sso-box">
      {{ $t('login.login_with') }} <v-btn color="darkprimary" text @click="gotoSSO()">{{ $t('login.corporate_account') }}</v-btn>
    </div>
  </div>
</template>

<script>
import SelectLanguageMenu from '@/components/SelectLanguageMenu.component.vue'
export default {
  components: { SelectLanguageMenu },
  name: "Login",
  components: {
    SelectLanguageMenu
  },
  computed: {
    changedStatus() {
      return this.$route.query.isChanged
        ? this.$t('validate.change_password_success')
        : false;
    }
  },
  created() {
    let sessionToken = this.$route.query?.sessionToken;
    if (sessionToken) {
      localStorage.setItem("sessionToken", sessionToken);
      this.$router.push("/");
    }
  },
  data() {
    return {
      isLoggingIn: false,
      username: "",
      password: "",
      isError: false
    };
  },
  props: {},
  methods: {
    async login() {
      try {
        this.isLoggingIn = true;
        const login = await this.$store.dispatch("user/login", {
          username: this.username,
          password: this.password,
          locale: this.$i18n.locale.includes('-') ? this.$i18n.locale.split('-')[1].toLowerCase() : this.$i18n.locale.toLowerCase()
        });
        if (login) {
          if (this.$route.query?.redirect) {
            this.$router.push(this.$route.query?.redirect);
          } else {
            this.$router.push("/");
          }
        }
      } catch (err) {
        this.isLoggingIn = false;
        this.isError = true;
      }
    },
    gotoSSO() {
      window.location.replace(process.env.VUE_APP_SSO_URL);
    }
  }
};
</script>

<style lang="scss" scoped>
.outer-auth-box {
  .auth-box {
    .image-box {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 300px;

      img {
        width: 200px;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }

    padding: 50px 40px 30px;
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 0px 12px 44px 0px #0000001F;

  }

  .divider-box {
    margin: 25px 0 15px;
    display: flex;
    gap: 25px;
    justify-content: center;
    align-items: center;

    .text {
      // padding: 0 15px;
      font-size: 12px;
      color: var(--v-darkgray-base);
    }
  }

  .sso-box {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--v-darkgray-base);
    font-size: 14px;

    .v-btn {
      font-size: 14px;
      letter-spacing: unset;
      padding: 0;
      height: unset;
      width: unset;
    }
  }
}

.link-forgot {
  padding: 0 !important;
  height: unset !important;
  min-width: unset !important;
  font-size: 14px !important;
  color: var(--v-info-darken2) !important;
  margin: 0;
  text-transform: unset;
  letter-spacing: unset;
  margin-bottom: 0px;
  float: right;
}

.link-forgot:hover {
  text-decoration: underline;
}

.link-forgot:hover::before {
  opacity: 0 !important;
}
</style>
